// THE BOT'S NAME IN UI AND LABEL TEXT: one place.
//
// The lead-facing name is per bot (`BotConfig.assistantName`). Wherever a label is about ONE club's conversation, lead,
// call or club, it uses THAT club's name; a club whose name is empty reads "the assistant". Generic Kyck wording (settings
// pages, the all-clubs funnel) uses the feature name, "AI SMS".
//
// ⚠️ Stored data codes (`samTexted`, `leadRepliedToSam`, `sam_started`, ...) are NOT renamed: only the LABELS here are.
// ⚠️ The booth and demo pages have their own bot and their own wording; they do not use this file.

/** The feature name, for generic (not per-club) contexts. */
export const AI_SMS = 'AI SMS';

/** Used when a club's bot has no name. */
export const FALLBACK_BOT_NAME = 'the assistant';

/** The name to put in a sentence, or "the assistant" when there is none. */
export function botNameOf(assistantName: string | null | undefined): string {
  const n = (assistantName ?? '').trim();
  return n === '' ? FALLBACK_BOT_NAME : n;
}

/** The same, for the START of a sentence ("The assistant has..."). A real name is left exactly as written. */
export function botNameAtStart(assistantName: string | null | undefined): string {
  const n = botNameOf(assistantName);
  return n === FALLBACK_BOT_NAME ? 'The assistant' : n;
}
